module.exports = __webpack_public_path__ + "images/root/mainVisual_appeal_pc_fe28a361759bf3274a97eefc40b89cb2.png";